import Card from "./card.js";
export default class ClassicCard extends Card {
  constructor(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m) {
    super(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m),
      (this.ae = "ab-classic-card"),
      (this.oe = !0);
  }
  bt() {
    const s = {};
    return (
      (s[Card.hs.ss] = Card.rs.ai),
      (s[Card.hs.os] = this.id),
      (s[Card.hs.cs] = this.viewed),
      (s[Card.hs.ns] = this.title),
      (s[Card.hs.ds] = this.imageUrl),
      (s[Card.hs.ps] = this.description),
      (s[Card.hs.us] = this.updated),
      (s[Card.hs.ls] = this.expiresAt),
      (s[Card.hs.URL] = this.url),
      (s[Card.hs.fs] = this.linkText),
      (s[Card.hs.xs] = this.aspectRatio),
      (s[Card.hs.bs] = this.extras),
      (s[Card.hs.gs] = this.pinned),
      (s[Card.hs.js] = this.dismissible),
      (s[Card.hs.zs] = this.clicked),
      (s[Card.hs.ks] = this.language),
      (s[Card.hs.qs] = this.altImageText),
      (s[Card.hs.vs] = this.test),
      s
    );
  }
}
